import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthStore } from 'src/app/stores/auth.store';
import { PaymentStore } from '../../store/payment-report.store';
import { AssetStore } from 'src/app/stores/asset.store';
import FormatCurrency from 'src/app/utils/format-currency-utils';
import { MatIcon } from '@angular/material/icon';
import { NickyButtonComponent } from '../../../../../../components/form/nicky-button/nicky-button.component';
import { PaymentUtils } from '../../utils/payment-utils';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-finish-step',
  imports: [TranslateModule, MatIcon, NickyButtonComponent],
  templateUrl: './finish-step.component.html',
})
export class FinishStepComponent implements OnInit {
  protected translate = inject(TranslateService);
  protected authStore = inject(AuthStore);
  protected assetStore = inject(AssetStore);
  protected formatCurrency = inject(FormatCurrency);
  protected toastr = inject(ToastrService);
  protected router = inject(Router);
  protected paymentStore = inject(PaymentStore);
  protected paymentUtils = inject(PaymentUtils);

  getSuccessPhrase() {
    return this.translate.instant('payment_flow.youSentToReceiverTheOweAmount', {
      receiver: this.paymentStore?.user?.()?.name || '',
      payingAsset: this.paymentStore.paymentDetailsComputed().payingAsset?.assetTicker,
      sendAmount: this.formatPrice(this.paymentStore.paymentDetailsComputed().quote?.price),
      settlementAsset: this.paymentStore.paymentDetailsComputed().settlementAsset?.assetTicker,
      amountOwed: this.formatPrice(this.paymentStore.paymentDetailsComputed().settlementAmount || 1, true),
    });
  }

  formatPrice(value: string | number, payingAsset?: boolean) {
    return this.paymentUtils.formatPrice(value, payingAsset);
  }

  redirectAfterPayment() {
    const uuidRefer = this.paymentStore?.targetUser?.()?.id || '';
    const route = this.authStore.authenticated()
      ? '/overview'
      : `/register?name=${this.paymentStore.paymentDetailsComputed().payerName}&email=${this.paymentStore.paymentDetailsComputed().email}` +
        (uuidRefer ? `&uuidRefer=${uuidRefer}` : '');

    this.router.navigateByUrl(route);
  }

  ngOnInit(): void {
    const successUrl = this.paymentStore.paymentRequest?.()?.successUrl;
    if (successUrl) {
      try {
        window.location.href = successUrl;
      } catch (error) {
        console.error('Navigation error:', error);
        this.toastr.error(this.translate.instant('unknownError'));
      }
    }
  }
}
